import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { WorkItemModel } from '../../../models/work-item';
import { UIWorkFieldModel, UIPropertyModel } from 'e5core-angular-services';

@Component({
  selector: 'e5core-ui-work-field-box',
  templateUrl: './e5core-ui-work-field-box.component.html',
  styleUrls: ['./e5core-ui-work-field-box.component.css']
})
export class E5coreUiWorkFieldBoxComponent implements OnInit {

  @Input() workItem$: BehaviorSubject<WorkItemModel> ;
  @Input() field: UIWorkFieldModel ;
  @Input() property: UIPropertyModel ;
  @Input() readonly: boolean;

  constructor(protected cd: ChangeDetectorRef) { }

  ngOnInit() {
    if (this.workItem$) {
      this.workItem$.subscribe(
        wi => this.cd.markForCheck()
      );
    }
  }

}
